import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  nameText: {
    width: "30%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  emailText: {
    width: "30%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      alignItems: "baseline",
      width: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  labelSpan: {
    color: "#092958",
    fontSize: "0.75rem",
    fontFamily: "Roboto,sans-serif",
    fontWeight: 700,
    lineHeight: 1.57,
    letterSpacing: "0.00714em",
  },
  clientText: {
    width: "10%",
    [theme.breakpoints.down("sm")]: {
      width: "30%",
    },
  },
}))

export default styles
